module.exports = __webpack_public_path__ + "img/linkedin_preto.f09eb147.png";